import { AppBundle } from 'api/optimalprint-sdk.d';

export interface CategoryState {
  isLoading: boolean;
  categories?: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response;
  filters?: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters;
  recentlyViewedProducts?: AppBundle.Api.Response.Product.V1.RecentlyViewedProductListV1Response.RecentlyViewedItem[];
  fetchedCategoryId?: number;
  sortBy?: number;
  pageNr?: number;
  familiesOffset: number;
  totalFamiliesFetched: number;
  totalFamiliesAvailable: number;
  categoryId?: number;
  currentCategory?: AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response;
  refetchFlag: boolean;
  gtmProductsData: { [designId: string]: any };
  gtmPauseEvents: boolean;
  activeCategories: number[];
}

export enum BasketItemActions {
  'EDIT' = 'EDIT',
  'SHARE' = 'SHARE',
  'DUPLOCATE' = 'DUPLICATE',
  'DELETE' = 'DELETE',
  'SAVE_FOR_LATER' = 'SAVE_FOR_LATER',
}

export interface BreadCrumb {
  title: string;
  url?: string;
}
export interface CategoryInfo {
  title: string;
  subTitle: string;
  description: string;
  breadCrumbs: BreadCrumb[];
}

export enum AttributeFilterOptionTemplate {
  BlockValueOption = 'BlockValueOption',
  CheckBoxOption = 'CheckBoxOption',
  ColorOption = 'ColorOption',
}

export enum FilterAttributeGroup {
  attributeFilters = 'attributeFilters',
  tagFilters = 'tagFilters',
}

export enum FilterTypeName {
  productType = 'ProductType',
  orientation = 'Orientation',
  paperFormat = 'PaperFormat',
  color = 'color',
}
